module.exports = __webpack_public_path__ + "static/media/event-assessment-end-screen-bg.76e84752.png";